var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{on:{"submit":function () { return null; }}},[_c('FormField',_vm._b({attrs:{"disabled":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'FormField',_vm.config,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }